// mic api url
/**
 *  线上api   https://dlxzzn.com/
 */
const micUrl = "https://dlxzzn.com/";

export default micUrl;
